import React, { FC, useMemo } from 'react';
import { EvIoGameMode } from '@okletsplay/core';
import { Typography } from '@mui/material';

interface EvIoTournamentTileLabelProps {
  gameMode: EvIoGameMode;
  gameDuration: number;
  teamSize: number;
}

const GAME_MODE_LABEL: Record<EvIoGameMode, string> = {
  [EvIoGameMode.TeamDeathmatch]: 'Team Deathmatch',
};

export const EvIoTournamentTileLabel: FC<EvIoTournamentTileLabelProps> = ({
  gameMode,
  gameDuration,
  teamSize,
}) => {
  const duration = useMemo(() => (gameDuration ? gameDuration / 60 : 0), [gameDuration]);
  const teamSizeLabel = useMemo(() => (teamSize ? `${teamSize}v${teamSize}` : ''), [teamSize]);

  if (!gameDuration && !gameMode) {
    return <Typography>Standard</Typography>;
  }

  return (
    <>
      {gameMode ? `${GAME_MODE_LABEL[gameMode]}` : ''}
      {gameMode && ' | '}
      {teamSizeLabel ? `${teamSizeLabel}` : ''}
      {duration && ' | '}
      {duration ? `${duration} min` : ''}
    </>
  );
};
